import { useIntl } from "react-intl";

import SimpleImageTextSide from "@/patterns/wpl/simple-image-text-side/src";

const TrackIssues = () => {
    const intl = useIntl();
    const title = intl.formatMessage({
        id: "JiraSoftwarePageTemplate.paidLpJswTracker.tabSection.trackIssues.title",
        defaultMessage: "Track bugs from backlog to done"
    });

    const bodyText = intl.formatMessage({
        id: "JiraSoftwarePageTemplate.paidLpJswTracker.tabSection.trackIssues.listItem.",
        defaultMessage:
            "Always stay in the know by tracking bugs and issues through your team's workflow. Jira Software has a powerful workflow engine, planning features, comprehensive search, and reporting capabilities designed to help you find, record, and track bugs in your software."
    });
    const imageSrc =
        "https://wac-cdn-2.atlassian.com/dam/jcr:60f995d4-5ef2-4750-abfd-43e6ffd32fbc/track-bugs2x.png?cdnVersion=ece";
    const imageAlt = "track bugs screenshot";

    return (
        <SimpleImageTextSide
            headerText={title}
            bodyText={bodyText}
            imageLink={imageSrc}
            imageAltText={imageAlt}
            alignItems={"top"}
            rowProps="4-8"
            className="simple-image-text-side-tabs"
        />
    );
};

export default TrackIssues;
